
import AdminPanel from '../../../Admin_Panel/adminLogin/AdminLogin'

const Home = () => {
  return (
   
        <>
         
          <div className="w-full max-w-none mx-auto p-0 m-0 overflow-hidden min-h-screen bg-gradient-to-tr from-purple-100 via-blue-100 to-purple-100">
           
          <AdminPanel />
       
          </div>
        </>
     

  
  )
}

export default Home